<div class="col-xs-12 enable-wrap">
  <div class="modal-header">
    <h3 class="modal-title" id="modal-title">{{UserName}}'s Resumes:</h3>
  </div>
  <div class="modal-body">
    @if (ResumeData.length > 0) {
      <p>You can activate an existing resume or upload a new one. It is strongly recommended to keep an active resume on your profile.</p>
    } @else {
      <p>You don't have any resumes on file. Please upload one to apply for this position.</p>
    }
    <div class="uploading-wrapper uploaded resume-table-wrapper">
      @if (ResumeData.length > 0) {
        <table class="pretty-table">
          <thead>
            <tr>
              <th class="col-name">File Name</th>
              <th class="col-date">Last Updated</th>
              <th class="col-action">Action</th>
            </tr>
          </thead>
          <tbody>
            @for (resume of ResumeData; track resume) {
              <tr [class.is-current]="resume.status === true">
                <td class="col-name">
                  <a class="icon-download-alt download-link" target="_self" title="Download"
                    (click)="onDownload($event, resume.attachment_url)"></a>
                  <a class="resume-title cursor-pointer" attachmentView
                    [value]="getAttachmentViewUrl(resume.attachment_url)">
                    {{ resume.file_name | ellipsis:55 }}
                  </a>
                </td>
                <td class="col-date">{{ resume.updated_at | apiDate: 'MM/dd/yyyy' }}</td>
                <td class="col-action">
                  @if (resume.status === true) {
                    <span class="current-pill">Current</span>
                  } @else {
                    <button class="activate-btn" (click)="updateResume(resume.resume_id, false, resume.file_name)">
                      Activate
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <div class="resume-empty">No resumes on file yet.</div>
      }
    </div>
      <p class="size">Accepted formats: DOC, DOCX, PDF &nbsp;|&nbsp; Maximum file size: 2 MB</p>
    </div>
    <div class="modal-footer">
        <div class="upload-new-file-button d-flex align-items-center float-start" [hidden]="enableDelete">
			<button class="btn  me-2" [disabled]="uploading" (click)="fileInput.click()">+ Resume</button>
			<input #fileInput [disabled]="uploading" class="form-control" type="file"
			  accept=".pdf,.doc,.docx," (change)="onFileChange($event)" style="display: none;">
		  </div>
		  <button class="cancel-changes-button large ms-auto" (click)="closeThisDialog()">Cancel</button>
      <button class="save-changes-button large ms-auto" [hidden]="enableDelete" [disabled]="!enableSave"
      (click)="update()">Save</button>
      <button class="delete-confirm-button large ms-auto" [hidden]="!enableDelete" (click)="delete()">Delete Resume</button>

    </div>
  </div>
